import { FetchRemotePage, fetchSearchPage } from 'reusable/RemoteSearch/remotePage';

/**
 * ADM-14 / BE-02。運転者の登録・編集で選べる機器の候補。
 *
 * サーバーが運転者へ割り当てられるのは、状態が「利用可能」で利用者のいない機器と、
 * その運転者がすでに使っている機器だけ（serializers.py の _assert_assignable）。
 * 「利用者なし」だけで絞ると修理中・故障の機器も候補に出て、保存すると
 * 400（device_not_available）になっていた。
 *
 * EV-493。以前は機器を全件（最大5,000件・50回の要求）読んで画面で絞っていた。候補の条件はサーバーの
 * 一覧で絞り（登録は assignable=true、編集は assignable_for=<運転者>。会社の範囲はサーバーが守る）、
 * 名前で検索して1ページずつ読む。
 */
export interface DeviceCandidate {
  id: number;
  name: string;
}

export function assignableDevicePage(driverId?: number): FetchRemotePage<DeviceCandidate> {
  return async (query, page) => {
    const result = await fetchSearchPage<{ id: number; name: string }>(
      '/v1/devices/',
      query,
      page,
      driverId !== undefined
        ? { assignable_for: driverId, order_by: 'name' }
        : { assignable: 'true', order_by: 'name' }
    );
    return { ...result, items: result.items.map((device) => ({ id: device.id, name: device.name })) };
  };
}
